import { Tooltip } from "@plum-xoxo/admin-dsm";
import React from "react";

const ToolTipText = ({ value = "", length = 22 }) => {
  return (
    <>
      {value?.length > length ? (
        <Tooltip
          offset={[0, 5]}
          tooltip={
            <div
              style={{
                wordBreak: "break-all",
              }}
            >
              {value}
            </div>
          }
          placement="bottom"
          width={200}
        >
          {value?.slice(0, length)}...
        </Tooltip>
      ) : (
        value
      )}
    </>
  );
};

export default ToolTipText;
